module.exports = __webpack_public_path__ + "static/media/robot.ed5fea18.svg";